const characterConfigs = {
  '500': {
    // Arjun
    model: '/models/characters/arjun.glb',
    position: [0.07, 0, 0],
    rotation: [0, 0.5, 0]
  },
  '501': {
    // Adele
    model: '/models/characters/adele.glb',
    position: [0.07, -0.1, 0],
    rotation: [0.1, 0.1, 0]
  },
  '502': {
    // Carlos
    model: '/models/characters/carlos.glb',
    position: [0.065, -0.15, 0],
    rotation: [0, 0.5, 0]
  },
  '503': {
    // Jack
    model: '/models/characters/jack.glb',
    position: [0.07, -0.1, 0],
    rotation: [0.1, 0.5, 0]
  },
  '504': {
    // Joan
    model: '/models/characters/joan.glb',
    position: [0.07, 0, 0],
    rotation: [0.1, 0.1, 0]
  },
  '505': {
    // Melisa
    model: '/models/characters/melisa.glb',
    position: [0.07, 0, 0],
    rotation: [0.1, 0.1, 0]
  },
  '506': {
    // Elderly Man
    model: '/models/characters/elderly-man.glb',
    position: [0.073, -0.1, 0],
    rotation: [0.1, 0.5, 0]
  },
  '507': {
    // Nurse
    model: '/models/characters/nurse.glb',
    position: [0.075, -0.1, 0],
    rotation: [0.1, 0, 0]
  },
  '508': {
    // Elderly Woman/Meiling
    model: '/models/characters/elderly-woman.glb',
    position: [0.075, 0, 0],
    rotation: [0.1, 0.05, 0]
  },

  // Coach avatar
  '1000': {
    // AI Coach
    model: '/models/characters/ai-coach.glb',
    position: [0.07, -0.07, 0],
    rotation: [0.1, 0.1, 0]
  }
};

export default characterConfigs;
